import { all, put, takeLatest } from 'redux-saga/effects';

import { types as uncheckedImpactingPolicyCountTypes } from '../ducks/uncheckedImpactingPolicyCount';

export function * watchUncheckedImpactingPolicyCount() {
    yield takeLatest(uncheckedImpactingPolicyCountTypes.UNCHECKED_IMPACTING_POLICY_COUNT_GET, onUncheckedImpactingPolicyCountGet);
    yield takeLatest(uncheckedImpactingPolicyCountTypes.UNCHECKED_IMPACTING_POLICY_COUNT_SUCCESS, onUncheckedImpactingPolicyCountGetResponse);
}

function * onUncheckedImpactingPolicyCountGet({ payload }) {
    payload.method = 'get';
    return yield payload;
}

function * onUncheckedImpactingPolicyCountGetResponse({ response, payload }) {
    if (payload.action === 'get' && response && payload.dataset === 'unchecked_impacting_policy_count') {
        return yield all([
            put({
                type: uncheckedImpactingPolicyCountTypes.UNCHECKED_IMPACTING_POLICY_COUNT_SET,
                payload: response,
            }),
        ]);
    }
}
